module.exports = __webpack_public_path__ + "img/lasource-10.7bd6efdd.jpg";